const navigation = {
  logo: { link: '/', name: 'E. Guerrero' },
  about: { link: '/#about', name: 'About' },
  projects: { link: '/#portfolio', name: 'Portfolio' },
  contact: { link: '/#contact', name: 'Contact' },
  github: { link: 'https://github.com/EGuerreroM', name: 'GitHub' },
  linkedin: {
    link: 'https://www.linkedin.com/in/beguerrero/',
    name: 'LinkedIn',
  },
};

export default navigation;
